import { v4 as uuidv4 } from 'uuid'
import { t } from 'ttag'

export const getColumns = () => [
  { header: t`department`, accessorKey: 'name', width: '100%' },
  { header: t`remove access`, id: uuidv4(), width: '8.5rem', alignRight: true },
]
